export class ResetEmailRequest {
  oldEmail: string;
  email: string;
  password: string;
  token: string;

  constructor(email: string, oldEmail: string, password: string, token: string) {
    this.email = email;
    this.oldEmail = oldEmail;
    this.password = password;
    this.token = token;
  }
}
